const e = "_wrapper_hdvzq_1", s = "_skeleton_hdvzq_4", t = {
  wrapper: e,
  skeleton: s
};
export {
  t as default,
  s as skeleton,
  e as wrapper
};
